import React from 'react';
import PlaceholderPage from '../../components/PlaceholderPage';

const Settings = () => {
  const icon = (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M34.4676 9.51282C33.3306 4.82907 26.6694 4.82907 25.5324 9.51282C24.7978 12.5385 21.3314 13.9743 18.6725 12.3542C14.556 9.84636 9.84636 14.556 12.3542 18.6725C13.9743 21.3314 12.5385 24.7978 9.51282 25.5324C4.82907 26.6694 4.82907 33.3306 9.51282 34.4676C12.5385 35.2022 13.9743 38.6686 12.3542 41.3275C9.84636 45.444 14.556 50.1536 18.6725 47.6458C21.3314 46.0257 24.7978 47.4615 25.5324 50.4872C26.6694 55.1709 33.3306 55.1709 34.4676 50.4872C35.2022 47.4615 38.6686 46.0257 41.3275 47.6458C45.444 50.1536 50.1536 45.444 47.6458 41.3275C46.0257 38.6686 47.4615 35.2022 50.4872 34.4676C55.1709 33.3306 55.1709 26.6694 50.4872 25.5324C47.4615 24.7978 46.0257 21.3314 47.6458 18.6725C50.1536 14.556 45.444 9.84636 41.3275 12.3542C38.6686 13.9743 35.2022 12.5385 34.4676 9.51282ZM30 39C34.9706 39 39 34.9706 39 30C39 25.0294 34.9706 21 30 21C25.0294 21 21 25.0294 21 30C21 34.9706 25.0294 39 30 39Z" fill="currentColor"/>
    </svg>
  );

  return (
    <PlaceholderPage
      title="Settings"
      description="Configure your admin panel settings. Manage preferences, integrations, and system configurations."
      icon={icon}
    />
  );
};

export default Settings;
